/**
 * Lead rating API (`GET/PUT /crm/api/leads/rating/`).
 */

export function leadRatingUrl(leadSource, leadRefId) {
  const params = new URLSearchParams({
    lead_source: leadSource,
    lead_ref_id: String(leadRefId),
  })
  return `/crm/api/leads/rating/?${params.toString()}`
}

export function getLeadRating(axios, leadSource, leadRefId) {
  return axios.get(leadRatingUrl(leadSource, leadRefId))
}

export function putLeadRating(axios, leadSource, leadRefId, rating) {
  return axios.put(leadRatingUrl(leadSource, leadRefId), { rating })
}
